var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRotateRightCpc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_394_9981)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6 5.6L11 1V4.1C7.1 4.6 4 7.9 4 12C4 16.1 7.1 19.4 11 19.9V17.9C8.2 17.4 6 15 6 12C6 9 8.2 6.6 11 6.1V10L15.6 5.6ZM19.9 11C19.7 9.6 19.2 8.3 18.3 7.1L16.9 8.5C17.4 9.3 17.8 10.1 17.9 11H19.9ZM13 17.9V19.9C14.4 19.7 15.7 19.2 16.9 18.3L15.5 16.9C14.7 17.4 13.9 17.8 13 17.9ZM16.9 15.5L18.3 16.9C19.2 15.7 19.8 14.4 19.9 13H17.9C17.8 13.9 17.4 14.7 16.9 15.5Z",
    fill: "#EA7F4A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_394_9981"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateRightCpc);
export default __webpack_public_path__ + "static/media/rotate_right_cpc.2f2423eebc54561f59411b6155931df6.svg";
export { ForwardRef as ReactComponent };